module.exports = __webpack_public_path__ + "img/menu.5c57f42f.svg";